import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, lastValueFrom } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { StateService } from '../services/state.service';

@Injectable()
export class SentryTransactionInterceptor implements HttpInterceptor {
  constructor(private state: StateService, private config: AppConfigService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    // convert promise to observable using 'from' operator
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<unknown>, next: HttpHandler) {
    const apiRequest = req.url.includes(this.config.apiEndpoint);
    if (!apiRequest || !this.state.sentryTransaction?.traceId) return lastValueFrom(next.handle(req));
    const headers = { 'sentry-trace': this.state.sentryTransaction.traceId };
    const newReq = req.clone({ setHeaders: headers });
    return lastValueFrom(next.handle(newReq));
  }
}
